<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  <!-- Toolbar -->
  <medsurf-design-content-toolbar class="mb-2">
    <div class="p-toolbar-group-start">
      <button medsurf-design-input-button id="user_add"
        [label]="'global.user_add' | translate"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
      (click)="addNewUser()"></button>
    </div>
  </medsurf-design-content-toolbar>
  <!-- Content -->
  @if (userSharedFacade.users$ | async; as users) {
    <p-table
      [value]="users"
      class="flex flex-1 overflow-hidden align-self-center w-11 lg:w-8 mb-2"
      styleClass="w-full"
      [rowTrackBy]="rowTrackBy"
      [scrollable]="true"
      scrollHeight="100%"
      selectionMode="single"
      (onRowSelect)="onRowSelect($event)"
      sortField="lastName">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="lastName">
            <span translate="global.last_name"></span> <p-sortIcon field="lastName"></p-sortIcon>
          </th>
          <th pSortableColumn="firstName">
            <span translate="global.first_name"></span> <p-sortIcon field="firstName"></p-sortIcon>
          </th>
          <th pSortableColumn="email">
            <span translate="global.email"></span> <p-sortIcon field="email"></p-sortIcon>
          </th>
          <th pSortableColumn="role">
            <span translate="global.role"></span> <p-sortIcon field="role"></p-sortIcon>
          </th>
          <th pSortableColumn="lastLogin">
            <span translate="global.last_login"></span> <p-sortIcon field="lastLogin"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr [pSelectableRow]="user.id">
          <td>
            {{ user.lastName }}
          </td>
          <td>
            {{ user.firstName }}
          </td>
          <td>
            {{ user.email }}
          </td>
          <td>
            {{ ('enum.user.' + user.role) | translate }}
          </td>
          <td>
            {{ user.lastLogin ? (user.lastLogin | date_shared:'timeago') : '-' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
